import ContainerOrders from './ContainerOrders';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import containerOrderActions from '../../redux/modules/containerOrder/containerOrderActions';
import { createLoadingSelector } from '../../redux/modules/loading/loadingSelectors';
import containerOrderConstants from '../../redux/modules/containerOrder/containerOrderConstants';
import { fetchVehicles } from '../../redux/modules/vehicles/vehiclesCreators';
import { getRoutes } from '../../redux/modules/route/routeSelectors';
import { loadRoutes } from '../../redux/modules/route/routeCreators';

const isContainerOrdersLoading = createLoadingSelector(
  containerOrderConstants.GET_CONTAINERORDER
);

function mapStateToProps(state) {
  return {
    isLoading: isContainerOrdersLoading(state),
    containerOrders: state.containerOrder.containerOrders,
    selectedOrderId: state.containerOrder.selectedOrderId,
    dateFilterValue: state.containerOrder.dateFilterValue,
    vehicles: state.vehicles,
    authentication: state.authentication,
    routes: getRoutes(state),
    containerOrderFilter: state.containerOrder.containerOrderFilter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    containerOrderActions: bindActionCreators(containerOrderActions, dispatch),
    fetchVehicles: bindActionCreators(fetchVehicles, dispatch),
    loadRoutes: bindActionCreators(loadRoutes, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContainerOrders);
